import React, { useEffect, useState } from "react";
import DateFilter from "../../../components/Date";
import callApi from "../../../services/api/apiClient";
import { useSelector } from "react-redux";
import moment from "moment/moment";
import { use } from "react";
import { set } from "lodash";
import LoadingComponent from "../../../components/loading/LoadingComponent";
import { saleTeamReportSlice } from "../../../helper/customSlice";
import { dispatchStore } from "../../../lib/dispatchStore";
import { Pagination } from "@mui/material";

const TeamDetails = () => {
  const [fromDate, setFromDate] = useState(moment().format("YYYY-MM-DD"));
  const [toDate, setToDate] = useState(moment().format("YYYY-MM-DD"));
  const [dateError, setDateError] = useState("");
  const [selectedTeam, setSelectedTeam] = useState(null);
  const [selectedUsergroup, setSelectedUsergroup] = useState(null);
  const [teams, setTeams] = useState([]);
  const [UserGroups, setUserGroups] = useState([]);
  const [data, setData] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);

  const ordersPerPage = 10;

  const Listpage = useSelector((state) => state?.saleTeamReportSlice?.Listpage);
  // console.log(Listpage, "Listpage");

  const TotalPage = useSelector(
    (state) => state?.saleTeamReportSlice?.TotalPage
  );
  // console.log(TotalPage, "TotalPage");

  const reachEnd = useSelector((state) => state?.saleTeamReportSlice?.reachEnd);
  console.log(reachEnd, "reachEnd");

  const saleTeamReportList = useSelector(
    (state) => state?.saleTeamReportSlice?.list
  );
  // console.log(saleTeamReportList, "saleTeamReportList");

  const getUserGroup = useSelector((state) => state?.user?.getUserGroup?.data);
  console.log(getUserGroup, "getUserGroup...");

  const userProfile = useSelector((state) => state?.user?.profile?.data);
  console.log(userProfile, "userProfile");

  const mainUserGroup = userProfile?.user_group?.is_main_group === true;
  console.log(mainUserGroup, "mainUserGroup");

  const filteredUserGroup = mainUserGroup
    ? getUserGroup
    : getUserGroup?.filter((group) => group.id === userProfile?.user_group?.id);
  console.log(filteredUserGroup, "filteredUserGroup");

  useEffect(() => {
    fetchUserGroups();
  }, []);

  const fetchUserGroups = async () => {
    const response = await callApi("user/getUserGroup")
      .loadingGroup("user")
      .executeDispatch();
    setUserGroups(response);
  };

  const fetchSaleTeams = async (userGroupId) => {
    if (!userGroupId) {
      setTeams([]);
      return;
    }

    try {
      const response = await callApi("report/SaleTeam")
        .withParam({ user_group_id: userGroupId }) // Pass userGroupId as a query parameter
        .loadingGroup("saleteam")
        .executeDispatch();

      console.log(response, "response sale teams");
      setTeams(response || []);
    } catch (error) {
      console.error("Error fetching sale teams:", error);
      setTeams([]);
    }
  };
  useEffect(() => {
    fetchTeamReport(selectedTeam?.team_id);
  }, [fromDate, toDate, selectedTeam, Listpage]);

  const fetchTeamReport = async (id) => {
    if (!id) return;
    let params = {
      page_no: Listpage,
      per_page: 10,
      date_from: moment(fromDate).format("YYYY-MM-DD"),
      date_to: moment(toDate).format("YYYY-MM-DD"),
    };
    if (selectedUsergroup) {
      params.user_group_id = selectedUsergroup;
    }
    try {
      await callApi("report/TeamReport")
        .loadingGroup("teamreport")
        .withKeyParameter({ id: id })
        .withParam(params)
        .execute()
        .then((response) => {
          console.log(response, "response team report");
          setData(response);
          dispatchStore(
            saleTeamReportSlice.actions.setSaleTeamReportList(
              response?.session_data
            )
          );
        });
    } catch (error) {
      console.error("Error fetching team data:", error);
    }
  };
  const validateDates = (from, to) => {
    if (from && to && moment(from).isAfter(to)) {
      setDateError("From Date cannot be later than To Date");
      // console.log(dateError, "dateError");
      return false;
    }
    setDateError("");
    return true;
  };

  const handleFromDateChange = (date) => {
    setFromDate((prevDate) => {
      if (validateDates(date, toDate)) {
        return date;
      }
      return prevDate;
    });
  };

  const handleToDateChange = (date) => {
    setToDate((prevDate) => {
      if (validateDates(fromDate, date)) {
        return date;
      }
      return prevDate;
    });
  };

  const handleTeamChange = (event) => {
    const selectedValue = event.target.value;
    const team = teams?.find(
      (team) => team?.team_id === parseInt(selectedValue)
    );
    setSelectedTeam(team);

    dispatchStore(saleTeamReportSlice.actions.setListpage(1));
    setCurrentPage(1);

    if (team) {
      fetchTeamReport(team.team_id); // Fetch the report for the selected team
    }
  };

  const handleUserGroupChange = (event) => {
    const selectedValue = event.target.value;
    const group = UserGroups.find(
      (group) => group?.id === parseInt(selectedValue)
    );
    setSelectedUsergroup(group);
    setSelectedTeam(null);
    setData(null);
    if (group) {
      fetchSaleTeams(group?.id); // Fetch teams for the selected user group
    } else {
      setTeams([]);
    }
  };

  // const handleChange = (event, value) => {
  //   // Update Redux page state
  //   dispatchStore(saleTeamReportSlice.actions.setListpage(value));

  //   // Fetch data for the new page
  //   setCurrentPage(value); // Optional if you use local state for tracking
  //   fetchTeamReport(selectedTeam?.team_id);

  //   if (Listpage != undefined && reachEnd == false) {
  //     dispatchStore(saleTeamReportSlice.actions.plusListpage(value));
  //   }
  // };

  const handleChange = async (event, value) => {
    try {
      // Update Redux state for Listpage
      dispatchStore(saleTeamReportSlice.actions.setListpage(value));

      // Fetch data for the selected page
      await fetchTeamReport(selectedTeam?.team_id);

      // Handle infinite scroll logic (if applicable)
      if (!reachEnd) {
        dispatchStore(saleTeamReportSlice.actions.plusListpage(value));
      }
    } catch (error) {
      console.error("Error fetching data for page change:", error);
    }
  };
  console.log(data, "data team report");

  return (
    <>
      <div className="container mx-auto text-[14px] px-4">
        <h1 className="text-xl font-bold  text-center mt-4 mb-4">
          Report by Sale Team
        </h1>
        {/* Filters */}
        <div className="flex flex-row items-center justify-start space-x-4 text-sm mb-8">
          <div className="flex flex-col">
            <DateFilter
              fromDate={fromDate}
              setFromDate={handleFromDateChange}
              toDate={toDate}
              setToDate={handleToDateChange}
            />
            {dateError && <p className="text-red-500 text-sm  ">{dateError}</p>}
          </div>

          <div className="flex flex-col">
            <label htmlFor="teamDropdown" className="text-gray-700 mb-2">
              Select Usergroup
            </label>
            <select
              id="teamDropdown"
              className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={selectedUsergroup?.id || ""}
              onChange={handleUserGroupChange}
            >
              <option value="">All</option>
              {filteredUserGroup?.map((usergroup) => (
                <option key={usergroup?.id} value={usergroup?.id}>
                  {usergroup?.name}
                </option>
              ))}
            </select>
          </div>

          <div className="flex flex-col">
            <label htmlFor="teamDropdown" className="text-gray-700 mb-2">
              Select Team
            </label>
            <select
              id="teamDropdown"
              className="border border-gray-300 rounded-md p-2 focus:outline-none focus:ring-blue-500 focus:border-blue-500"
              value={selectedTeam?.team_id || ""}
              onChange={handleTeamChange}
              disabled={!selectedUsergroup}
            >
              <option value="" disabled>
                select team
              </option>
              {teams.map((team) => (
                <option key={team.team_id} value={team.team_id}>
                  {team.team_name}
                </option>
              ))}
            </select>
          </div>
        </div>

        {data ? (
          <div className="w-full max-w-4xl mt-8">
            <h2 className="font-bold text-lg">
              Report for Team {data?.team_name ? `"${data?.team_name}"` : ""}
            </h2>
            <div className="flex justify-start items-start py-4 text-sm text-gray-800 gap-6 w-auto">
              <ul className="space-y-1">
                <li className="grid grid-cols-[2fr_1fr_1fr]">
                  <b className=" items-center">Total sale amount</b>
                  <b className="text-center">:</b>
                  <b className="text-end">
                    {data?.total_sale_amount
                      ? data?.total_sale_amount?.toLocaleString()
                      : 0}
                  </b>
                </li>
                <li className="grid grid-cols-[2fr_1fr_1fr]">
                  <b className=" items-center">Total gross profit</b>
                  <b className="text-center">:</b>
                  <b className=" text-end">
                    {data?.total_gross
                      ? data?.total_gross?.toLocaleString()
                      : 0}
                  </b>
                </li>
                <li className="grid grid-cols-[2fr_1fr_1fr]">
                  <b className=" items-center">Total Live Sale Sessions</b>
                  <b className="text-center">:</b>
                  <b className=" text-end">
                    {data?.total_live_sale_sessions
                      ? data?.total_live_sale_sessions?.toLocaleString()
                      : 0}
                  </b>
                </li>
              </ul>
              <ul className="space-y-1">
                <li className="grid grid-cols-[2fr_1fr_1fr]">
                  <b className=" items-center">Total Sale Order</b>
                  <b className="text-center">:</b>
                  <b className=" text-end">
                    {data?.total_sale_order_count
                      ? data?.total_sale_order_count?.toLocaleString()
                      : 0}
                  </b>
                </li>
                <li className="grid grid-cols-[2fr_1fr_1fr]">
                  <b className=" items-center">Total Product Sold</b>
                  <b className="text-center">:</b>
                  <b className=" text-end">
                    {data?.total_product_sold
                      ? data?.total_product_sold?.toLocaleString()
                      : 0}
                  </b>
                </li>
              </ul>
            </div>
            {data?.session_data?.data?.length > 0 ? (
              <>
                <LoadingComponent
                  loadingGroup="teamreport"
                  loadingDesign={true}
                >
                  <table className="table-auto border-collapse border border-gray-400 w-full shadow-sm mb-6">
                    <thead>
                      <tr className="bg-[#164571] text-white-1">
                        <th className="border border-gray-400 px-4 py-2">No</th>
                        <th className="border border-gray-400 px-4 py-2">
                          Session
                        </th>
                        <th className="border border-gray-400 px-4 py-2">
                          Barcode
                        </th>
                        <th className="border border-gray-400 px-4 py-2">
                          Date
                        </th>
                        <th className="border border-gray-400 px-4 py-2">
                          Sale Person
                        </th>
                        <th className="border border-gray-400 px-4 py-2">
                          Total Orders
                        </th>
                        <th className="border border-gray-400 px-4 py-2">
                          Total Amount
                        </th>
                        <th className="border border-gray-400 px-4 py-2">
                          Gross Profit
                        </th>
                        <th className="border border-gray-400 px-4 py-2">
                          Sold Product Count
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {data?.session_data?.data?.map((row, index) => (
                        <tr key={index} className="text-center">
                          <td className="border border-gray-400 px-4 py-2">
                            {(Listpage - 1) * ordersPerPage + index + 1}
                          </td>
                          <td className="border border-gray-400 px-4 py-2 text-center">
                            {row.session}
                          </td>
                          <td className="border border-gray-400 px-4 py-2">
                            {row.barcode}
                          </td>
                          <td className="border border-gray-400 px-4 py-2">
                            {moment(row.date).format("DD/MM/YYYY")}{" "}
                          </td>
                          <td className="border border-gray-400 px-4 py-2">
                            {row.team_member ? row.team_member.name : "-"}
                          </td>
                          <td className="border border-gray-400 px-4 py-2">
                            {row.total_orders}
                          </td>
                          <td className="border border-gray-400 px-4 py-2 text-end">
                            {row.total_amount.toLocaleString()}
                          </td>
                          <td className="border border-gray-400 px-4 py-2 text-end">
                            {row.total_gross.toLocaleString()}
                          </td>
                          <td className="border border-gray-400 px-4 py-2">
                            {row.total_product_count}
                          </td>
                        </tr>
                      ))}
                      {/* <tr className="bg-gray-300 text-right ">
                      <td
                        className="border border-gray-400  px-4 py-2 font-bold text-left"
                        colSpan={2}
                      >
                        Total
                      </td>
                      <td className="border border-gray-400  px-4 py-2">
                        {data?.total_sale_order_count}
                      </td>
                      <td className="border border-gray-400  px-4 py-2">
                        {data?.total_sale_amount.toLocaleString()}
                      </td>
                      <td className="border border-gray-400  px-4 py-2">
                        {data?.total_gross.toLocaleString()}
                      </td>
                      <td className="border border-gray-400  px-4 py-2">
                        {data?.total_product_sold}
                      </td>
                    </tr> */}
                    </tbody>
                  </table>

                  {data?.session_data?.data?.length > 0 && TotalPage > 0 && (
                    <div className="flex justify-center mt-3 mb-6 bottom-0 w-full ">
                      <Pagination
                        count={TotalPage}
                        page={Listpage}
                        onChange={handleChange}
                        color="primary"
                      />
                    </div>
                  )}
                </LoadingComponent>
              </>
            ) : (
              <div className="text-gray-600 text-sm mt-2">
                No data available for the selected team.
              </div>
            )}
          </div>
        ) : (
          selectedTeam && (
            <div className="text-gray-600 text-sm mt-2">
              No data available for the selected team.
            </div>
          )
        )}
      </div>
      {!selectedTeam && (
        <div className="text-yellow-500 flex items-center justify-center h-full">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            strokeWidth={1.5}
            stroke="currentColor"
            className="size-6 mr-4"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z"
            />
          </svg>
          Please select user group and team.
        </div>
      )}
    </>
  );
};

export default TeamDetails;
